export const MODULE_NAMES = [
  'platform',
  'core',
  'people',
  'ops',
  'data',
  'analytics',
  'scada',
  'iot',
  'inv',
] as const;

export const ALWAYS_ON_MODULE_NAMES = [
  'platform',
] as const;

export const JOB_KEYS = [
  'analytics.eventTemplates.create',
  'analytics.eventTemplates.delete',
  'analytics.eventTemplates.read',
  'analytics.eventTemplates.update',
  'analytics.events.create',
  'analytics.events.delete',
  'analytics.events.read',
  'analytics.events.update',
  'analytics.triggers.create',
  'analytics.triggers.delete',
  'analytics.triggers.read',
  'analytics.triggers.update',
  'core.plantDetails.create',
  'core.plantDetails.delete',
  'core.plantDetails.read',
  'core.plantDetails.update',
  'core.plc.create',
  'core.plc.delete',
  'core.plc.read',
  'core.plc.update',
  'core.reports.create',
  'core.reports.delete',
  'core.reports.read',
  'core.reports.update',
  'data.corrections.apply',
  'data.inputTemplates.create',
  'data.inputTemplates.delete',
  'data.inputTemplates.read',
  'data.inputTemplates.update',
  'data.labEntry.create',
  'data.labEntry.delete',
  'data.labEntry.read',
  'data.labEntry.update',
  'data.logbookConfig.create',
  'data.logbookConfig.delete',
  'data.logbookConfig.read',
  'data.logbookConfig.update',
  'data.logbookTemplates.create',
  'data.logbookTemplates.delete',
  'data.logbookTemplates.read',
  'data.logbookTemplates.update',
  'inv.movementLogs.view',
  'inv.stock.create',
  'inv.stock.delete',
  'inv.stock.read',
  'inv.stock.update',
  'iot.logger.create',
  'iot.logger.delete',
  'iot.logger.read',
  'iot.logger.update',
  'ops.approvals.forceClose',
  'ops.approvals.gates',
  'ops.approvals.photoOverride',
  'ops.approvals.reopen',
  'ops.approvals.selfApprove',
  'ops.assignments.assign',
  'ops.assignments.plantWideShiftView',
  'ops.insights.create',
  'ops.insights.delete',
  'ops.insights.read',
  'ops.insights.update',
  'ops.issueSessions.create',
  'ops.issueSessions.delete',
  'ops.issueSessions.read',
  'ops.issueSessions.update',
  'ops.issues.comment',
  'ops.issues.report',
  'ops.oversight.coSign',
  'ops.photoEvidence.create',
  'ops.photoEvidence.delete',
  'ops.photoEvidence.read',
  'ops.photoEvidence.update',
  'ops.shifts.create',
  'ops.shifts.delete',
  'ops.shifts.read',
  'ops.shifts.update',
  'ops.templates.create',
  'ops.templates.delete',
  'ops.templates.read',
  'ops.templates.update',
  'ops.workflows.create',
  'ops.workflows.delete',
  'ops.workflows.read',
  'ops.workflows.update',
  'platform.profile.create',
  'platform.profile.delete',
  'platform.profile.read',
  'platform.profile.update',
  'scada.visualisation.create',
  'scada.visualisation.delete',
  'scada.visualisation.read',
  'scada.visualisation.update',
] as const;

export const ADMIN_KEYS = [
  'analytics.formulas.manage',
  'core.config.manage',
  'core.siteSetup.licence',
  'core.siteSetup.plant',
  'core.siteSetup.templates',
  'inv.catalog.manage',
  'iot.sensorConfig.hardware',
  'iot.sensorConfig.sensors',
  'ops.rules.flows',
  'ops.rules.manage',
  'ops.rules.routing',
  'people.access.export',
  'people.access.grants',
  'people.access.invite',
  'people.access.notifications',
  'people.access.roster',
  'people.access.skills',
  'people.rosters.manage',
  'platform.governance.library',
  'platform.governance.onboard',
  'platform.governance.publish',
] as const;

export const EXCEPTION_MODULE = {
  REMOTE_ACTUATION: 'iot',
  VIEW_AS_USER: 'platform',
  SENSOR_HEALTH: 'iot',
} as const;
